export function clearErrors() {
  return {
    type: 'CLEAR_ERRORS'
  }
}